import React from 'react';
import * as actions from '../store/actions/index';
import { connect } from 'react-redux';
import HeroPerson from '../components/HeroPerson/HeroPerson';
import PersonBiography from '../components/PersonBiography/PersonBiography';
import PersonFilmography from '../components/PersonFilmography/PersonFilmography';

class PersonContainer extends React.PureComponent {
  componentDidMount() {
    this.loadTitleInfo();
  }

  loadTitleInfo = () => {
    const { id } = this.props.match.params;
    this.props.onFetchPersonInfo(id);
  };

  backHandler = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      personInfo,
      personInfo: { cast },
    } = this.props;

    return (
      <div className="title-page-container">
        <HeroPerson backTo={this.backHandler} {...personInfo} />
        <div className="main-content">
          <PersonBiography {...personInfo}>Biography</PersonBiography>
          <PersonFilmography {...cast} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  personInfo: state.personInfoReducer.personInfo,
});

const mapDispatchToProps = dispatch => ({
  onFetchPersonInfo: type => dispatch(actions.fetchPersonInfo(type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonContainer);
